import axios from "axios";

export const getPost = (id) => {
  return axios.get(`/external/posts/${id}`);
};

export const likePost = (id) => {
  return axios.post(`/posts/${id}/like`);
};

export const unlikePost = (id) => {
  return axios.post(`/posts/${id}/unlike`);
};
